import React from 'react';

import Header from '../partials/Header';
import Footer from '../partials/Footer';

import ProjectsIntroPast from '../partials/ProjectsIntroPast'
import ProjectsListPast from '../partials/ProjectsListPast'


function Projects() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <ProjectsIntroPast />
        <ProjectsListPast />


      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Projects;